<template>

  <div class="main" ref="main">

    <headr></headr>

    <div id="pc">
      <div class="main-1">

        <div class="main-1-1">
          <div>
            <div>
              <img src="@/img/pc/Frame 3364@2x.png" alt="">
              <span>截屏提醒 双向撤回</span>
            </div>
            <img src="@/img/pc/Group 57@2x.png" alt="">
          </div>
          <div><span>海鸥APP 全方位守护你的隐私安全</span></div>
          <div><span>拥有私聊、群聊、密信、建群等通讯功能</span></div>
          <div><span>消息必达 全程加密 全球互通 消息回执</span></div>
          <div><img src="@/img/pc/qr.png" alt=""></div>
          <div>

            <div @mouseenter="mouseTypeAndroid=true" @mouseleave="mouseTypeAndroid=false"
              :style="mouseTypeAndroid==true?'cursor: pointer;background: #FFFFFF;box-shadow: 0px 0px 8px 0px rgba(166,187,253,0.5);border-radius: 8px 8px 8px 8px;':'cursor: pointer;background: #4371FF;border-radius: 8px 8px 8px 8px;'"
              @click="download('android')"><img
                :src="mouseTypeAndroid==true?require('@/img/pc/android@2x (1).png'):require('@/img/pc/android@2x.png')"
                alt="">
              <div><span :style="mouseTypeAndroid==true?'color: #4371FF;':'color: #FFFFFF;'">安卓下载</span><span
                  :style="mouseTypeAndroid==true?'color: #4371FF;':'color: #FFFFFF;'">Android</span></div>
            </div>

            <div @mouseenter="mouseTypeIos=true" @mouseleave="mouseTypeIos=false"
              :style="mouseTypeIos==true?'cursor: pointer;background: #FFFFFF;box-shadow: 0px 0px 8px 0px rgba(166,187,253,0.5);border-radius: 8px 8px 8px 8px;':'cursor: pointer;background: #4371FF;border-radius: 8px 8px 8px 8px;'"
              @click="download('ios')"><img
                :src="mouseTypeIos==true?require('@/img/pc/ios@2x (1).png'):require('@/img/pc/ios@2x.png')" alt="">
              <div><span :style="mouseTypeIos==true?'color: #4371FF;':'color: #FFFFFF;'">苹果下载</span><span
                  :style="mouseTypeIos==true?'color: #4371FF;':'color: #FFFFFF;'">App Store</span></div>
            </div>

            <div @mouseenter="mouseTypeWeb=true" @mouseleave="mouseTypeWeb=false"
              :style="mouseTypeWeb==true?'cursor: pointer;background: #FFFFFF;box-shadow: 0px 0px 8px 0px rgba(166,187,253,0.5);border-radius: 8px 8px 8px 8px;':'cursor: pointer;background: #4371FF;border-radius: 8px 8px 8px 8px;'"
              @click="download('web')"><img
                :src="mouseTypeWeb==true?require('@/img/pc/web@2x-1.png'):require('@/img/pc/web@2x.png')" alt="">
              <div><span :style="mouseTypeWeb==true?'color: #4371FF;':'color: #FFFFFF;'">web端登录</span><span
                  :style="mouseTypeWeb==true?'color: #4371FF;':'color: #FFFFFF;'">海鸥网页</span></div>
            </div>

            <div @mouseenter="mouseTypeWindows=true" @mouseleave="mouseTypeWindows=false"
              :style="mouseTypeWindows==true?'cursor: pointer;background: #FFFFFF;box-shadow: 0px 0px 8px 0px rgba(166,187,253,0.5);border-radius: 8px 8px 8px 8px;':'cursor: pointer;background: #4371FF;border-radius: 8px 8px 8px 8px;'"
              @click="download('windows')"><img
                :src="mouseTypeWindows==true?require('@/img/pc/windows-1.png'):require('@/img/pc/windows-2.png')" alt="">
              <div><span :style="mouseTypeWindows==true?'color: #4371FF;':'color: #FFFFFF;'">windows下载</span><span
                  :style="mouseTypeWindows==true?'color: #4371FF;':'color: #FFFFFF;'">windows</span></div>
            </div>



          </div>
          <div>*如存在安装问题，可移步各大应用市场搜索[海鸥APP]进行下载安装!</div>
        </div>
        <div class="main-1-2">
          <div> <img src="@/img/pc/Frame 3364@2x.png" alt=""> <span>超级千人万人大群</span></div>
          <div> <img src="@/img/pc/Frame 3364@2x.png" alt=""> <span>安全加密 消息回执</span></div>
          <div> <img src="@/img/pc/Frame 3364@2x.png" alt=""> <span>多人通话 应用锁保护</span></div>
          <img src="@/img/pc/Frame 1010104487@2x.png" alt="">

        </div>

      </div>


      <div class="main-2">
        <img src="@/img/pc/Frame 37638@2x.png" alt="">
      </div>


      <div class="main-3">
        <span>多样化消息类型 全面满足通讯需求</span>
        <span>保护聊天隐私，避免您的聊天信息（消息、照片、语音、视频、文件等）泄漏他人的手中。</span>
        <div>
          <div>
            <img src="@/img/pc/Frame@2x(15).png" alt="">
            <span>应用锁保护</span>
            <span>应用所锁守护你的私人领域，防止旁人窥探隐私</span>
            <span>
              <router-link to="/security">了解安全技术</router-link>
            </span>
          </div>

          <div>
            <img src="@/img/pc/Frame@2x(14).png" alt="">
            <span>超级万人群</span>
            <span>趣味畅聊，支持多人语音通话，有强大群管控权限</span>
            <span>
              <router-link to="/security">了解安全技术</router-link>
            </span>
          </div>

          <div>
            <img src="@/img/pc/Frame@2x(13).png" alt="">
            <span>安全学堂</span>
            <span>对方被举报次数过多，则会提醒用户对方是危险好友</span>
            <span>
              <router-link to="/security">了解安全技术</router-link>
            </span>
          </div>


          <div>
            <img src="@/img/pc/Frame@2x(12).png" alt="">
            <span>群管家设置</span>
            <span>强大的群管理权限，一键操作，应对万级群成员</span>
            <span>
              <router-link to="/security">了解安全技术</router-link>
            </span>
          </div>

          <div>
            <img src="@/img/pc/Frame@2x(11).png" alt="">
            <span>群发好友</span>
            <span>可选择多个好友发送消息，去除繁琐操作</span>
            <span>
              <router-link to="/security">了解安全技术</router-link>
            </span>
          </div>

          <div>
            <img src="@/img/pc/Frame@2x(10).png" alt="">
            <span>等级排名</span>
            <span>用户个人账号形象最大化展示，等级越高排名越靠前</span>
            <span>
              <router-link to="/security">了解安全技术</router-link>
            </span>
          </div>

        </div>
      </div>



      <div class="main-3-3">
        <span>安全可靠的通讯软件</span>
        <span>消息和文件都是通过加密后发送，您可以放心地畅所欲言，与最重要的人保持紧密联系。</span>
        <div>
          <div>
            <img src="@/img/pc/1@2x.png" alt="">
            <span>信息加密</span>
            <span>采用加密保护，确保聊天信息不被泄漏。文字、图片、语音、视频、文件、气泡、表情等丰富的聊天功能。</span>

          </div>

          <div>
            <img src="@/img/pc/2@2x.png" alt="">
            <span>截屏通知</span>
            <span>再也不用担心消息泄漏。守护你的私人领域，防止旁人窥探隐私。</span>

          </div>

          <div>
            <img src="@/img/pc/3@2x.png" alt="">
            <span>强大群控</span>
            <span>千人万人大群 ，趣味畅聊，支持多人语音通话，有强大群管控权限</span>

          </div>


        </div>
      </div>


      <div class="main-7">
        <div>
          <p>部分APP页面展示</p>
          <p>界面简洁纯粹 无广告</p>
          <img src="@/img/pc/Slice 2@2x.png" alt="">
        </div>

        <div>
          <bottom ref="bo"></bottom>
        </div>

      </div>

    </div>

    <!-- 移动端 -->
    <div id="mobile">

      <div class="mobile-1">
        <div>
          <p>海鸥通讯聊天</p>
          <p>全方位守护你的隐私安全</p>
          <p>拥有私聊｜群聊｜密信｜建群等功能</p>
          <div>
            <div @click="download('ios')"><img src="@/img/mobile/ios@2x.png" alt=""><span>苹果下载</span></div>
            <div @click="download('android')"><img src="@/img/mobile/android@2x.png" alt=""><span>安卓下载</span></div>
          </div>
        </div>
        <div>
          <p>核心优势</p>
          <p>私密事用海鸥，更安全更私密</p>
        </div>
        <div>

          <div>
            <img src="@/img/mobile/Frame@2x(13).png" alt="">
            <div>
              <p>截屏提醒</p>
              <p>聊天截屏实时提醒</p>
            </div>
          </div>

          <div>
            <img src="@/img/mobile/Frame@2x(12).png" alt="">
            <div>
              <p>群聊盖楼</p>
              <p>疯狂跟帖群起而论之</p>
            </div>
          </div>

          <div>
            <img src="@/img/mobile/Frame@2x(11).png" alt="">
            <div>
              <p>安全加密</p>
              <p>消息都经过安全加密</p>
            </div>
          </div>

          <div>
            <img src="@/img/mobile/Frame@2x(10).png" alt="">
            <div>
              <p>定时清理消息</p>
              <p>设置后按时清理</p>
            </div>
          </div>

          <div>
            <img src="@/img/mobile/Frame@2x(9).png" alt="">
            <div>
              <p>多人通话</p>
              <p>提高沟通效率</p>
            </div>
          </div>

          <div>
            <img src="@/img/mobile/Frame@2x(8).png" alt="">
            <div>
              <p>一键删除好友</p>
              <p>再也不用花时间清理</p>
            </div>
          </div>
        </div>
      </div>

      <div class="mobile-2">
        <img src="@/img/mobile/Frame 1010104466@2x.png" alt="">
      </div>

      <div class="mobile-3">

        <p>多样化消息类型 全面满足通讯需求</p>
        <p>保护聊天隐私，避免您的聊天信息（消息、照片、语音、视频、文件等）泄漏他人的手中。</p>
        <div>
          <div>
            <img src="@/img/mobile/Frame@2x(7).png" alt="">
            <p>应用锁保护</p>
            <p>应用所锁守护你的私人领域，防止旁人窥探隐私</p>
            <p>
              <router-link to="/security">了解安全技术</router-link>
            </p>
          </div>

          <div>
            <img src="@/img/mobile/Frame@2x(6).png" alt="">
            <p>超级万人群</p>
            <p>趣味畅聊，支持多人语音通话，有强大群管控权限</p>
            <p>
              <router-link to="/security">了解安全技术</router-link>
            </p>
          </div>

          <div>
            <img src="@/img/mobile/Frame@2x(5).png" alt="">
            <p>安全学堂</p>
            <p>对方被举报次数过多，则会提醒用户对方是危险好友</p>
            <p>
              <router-link to="/security">了解安全技术</router-link>
            </p>
          </div>

          <div>
            <img src="@/img/mobile/Frame 1010104473@2x.png" alt="">
            <p>群管家设置</p>
            <p>强大的群管理权限，一键操作，应对万级群成员</p>
            <p>
              <router-link to="/security">了解安全技术</router-link>
            </p>
          </div>

          <div>
            <img src="@/img/mobile/Frame@2x(4).png" alt="">
            <p>群发好友</p>
            <p>可选择多个好友发送消息，去除繁琐操作</p>
            <p>
              <router-link to="/security">了解安全技术</router-link>
            </p>
          </div>

          <div>
            <img src="@/img/mobile/Frame@2x(3).png" alt="">
            <p>等级排名</p>
            <p>用户个人账号形象最大化展示，等级越高排名越靠前</p>
            <p>
              <router-link to="/security">了解安全技术</router-link>
            </p>
          </div>

        </div>
      </div>

      <div class="mobile-3-3">
        <p>安全可靠的通讯软件</p>
        <p>保护聊天隐私，避免您的聊天信息（消息、照片、语音、视频、文件等）泄漏他人的手中。</p>
      </div>

      <div class="mobile-4">
        <img src="@/img/mobile/1@2x.png" alt="">
        <p>信息加密</p>
        <p>采用加密保护，确保聊天信息不被泄漏。文字、图片、语音、视频、文件、气泡、表情等丰富的聊天功能。</p>

      </div>

      <div class="mobile-5">
        <img src="@/img/mobile/1@2x (1).png" alt="">
        <p>截屏通知</p>
        <p>再也不用担心消息泄漏。守护你的私人领域，防止旁人窥探隐私。</p>

      </div>

      <div class="mobile-6">
        <img src="@/img/mobile/1@2x (2).png" alt="">
        <p>强大群控</p>
        <p>千人万人大群 ，趣味畅聊，支持多人语音通话，有强大群管控权限</p>

      </div>

      <div class="mobile-7">

        <p>部分APP页面展示</p>
        <p>界面简洁纯粹 无广告</p>

        <img src="@/img/mobile/Slice 4@2x.png" alt="">
      </div>



      <bottom></bottom>
      <down></down>


    </div>




  </div>

</template>
<script type="text/javascript" charset="UTF-8" src="https://cdn.xinstall.com/xinstall.js"></script>
<script>
  import api from "@/api/api";
  import request from '@/api/request';
  import headr from '@/components/head/index'
  import bottom from '@/components/bottom/index'
  import down from '@/components/down/index'

  import Base64 from 'base-64';
  import {
    Notify
  } from 'vant';
  import {
    Dialog
  } from 'vant';
  export default {
    components: {
      headr,
      bottom,
      down
    },
    data() {
      return {
        carouselIndex: 0,
        elCarouselHeight: '90vh',
        vanSwipeIndex: 0,
        bottomShow: false,
        downShow: false,
        isSwipeDisabled: true,
        downStype: "width:100%;position: absolute;bottom: 0;",
        handleMouse: false,

        mouseTypeAndroid: false,
        mouseTypeAndroidYes: "false",
        mouseTypeAndroidNo: "false",

        mouseTypeIos: false,
        mouseTypeIosYes: "false",
        mouseTypeIosNo: "false",

        mouseTypeWeb: false,
        mouseTypeWebYes: "false",
        mouseTypeWebNo: "false",

        mouseTypeWindows: false,
        mouseTypeWindowsYes: "false",
        mouseTypeWindowsNo: "false",

        xInstall:null

      }
    },
    created() {
      localStorage.clear()
      var xInstallData = XInstall.parseUrlParams();
      console.log(xInstallData)
      if (xInstallData&&Object.keys(xInstallData).length>0) {
        localStorage.setItem('xInstallData',JSON.stringify(xInstallData))
      }else{
        xInstallData = JSON.parse(localStorage.getItem('xInstallData')) 
      }
     
   
      if (xInstallData) {
        let data = {
          account:xInstallData.account,
          XinShareId:xInstallData.XinShareId,
        }
       this.xInstall = new XInstall({
          appKey: "hnzdq5i",
          buttonId: [{
            idName: 'Button1',
            params: {
              account: xInstallData.account,
              XinShareId: xInstallData.XinShareId
            }
          }, ],
          /*xinstall初始化完成的回调函数*/
          onready: function () {

          }
        }, data);
      }

    },
    computed: {

    },
    mounted() {
      this.$refs.main.addEventListener("mousewheel", this.handleMousewheel) || this.$refs.main.addEventListener(
        "DOMMouseScroll", this.handleMousewheel);

    },

    destroyed() {

    },
    methods: {
      download(type) {
        if (type == 'android') {
          this.$router.push('/toDown');
        }
        if (type == 'ios') {
          if(this.xInstall){
            console.log('走第三方下载')
            this.xInstall.wakeupOrInstall();
          }else{
             window.location.href = api.apiConfig.iosUrl
          }
         
        
        }

        if (type == 'web') {
          window.open(api.apiConfig.haiouWeb, '_blank');
        }
        if (type == 'windows') {
          this.toDown(api.apiConfig.windows)
          //window.location.href = api.apiConfig.windowsUrl
        }
        

      },
      swipedown(txt, event) {
        //alert("dsafds")
        this.isSwipeDisabled = true;

      },
      vanSwipeChange(index) {
        console.log(index)
        //console.log(this.$refs.vanSwipe)
        //this.$refs.vanSwipe.resize();
        if (index == 6) {
          this.bottomShow = true
        } else {
          this.bottomShow = false
        }
        this.vanSwipeIndex = index

        if (index == 0) {
          this.downShow = false
          this.downStype = "width:100%;position: absolute;bottom: 0;"
        } else if (index == 6) {
          this.downShow = true
          this.downStype = ""
          this.isSwipeDisabled = false;

          setTimeout(() => {
            this.isSwipeDisabled = true;

          }, 3000); // 暂停3秒钟（3000毫秒）



        } else {
          this.downShow = true
          this.downStype = "width:100%;position: absolute;bottom: 0;"
        }
      },
      handleMousewheel(event) {

        // 防止连续滚动
        //event.preventDefault();
        console.log(this.handleMouse)
        if (this.handleMouse == false) {

          this.handleMouse = true
          //setTimeout(() => {

          if ((event.wheelDelta < 0 || event.detail > 0)) {
            console.log(this.carouselIndex)
            if (this.carouselIndex == 6) {
              this.elCarouselHeight = '130vh'
            }
            if (this.carouselIndex < 7 - 1) {
              this.$refs.elcar.next()
            }

          } else {

            this.elCarouselHeight = '90vh'
            console.log(this.carouselIndex)
            if (this.carouselIndex > 0) {
              this.$refs.elcar.prev()
            }

          }

          var userAgent = navigator.userAgent;
          var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
          var isIOS = !!userAgent.match(/macintosh|mac os x/i);
          //alert(isIOS)
          //0 安卓 1 ios
          var type = 0;
          if (isIOS) {
            setTimeout(() => {
              this.handleMouse = false
            }, 850);

          } else {
            this.handleMouse = false
          }

          // }, 100); // 暂停3秒钟（3000毫秒）


        }




      },
      change(index) {
        this.carouselIndex = index;
      },
      downApp() {
        var userAgent = navigator.userAgent;
        //console.log(userAgent)
        //alert(userAgent)
        var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
        var isIOS = !!userAgent.match(/macintosh|mac os x/i);
        //alert(isIOS)
        //0 安卓 1 ios
        var type = 0;
        if (isIOS) {
          //window.location.href = 'https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5m/id6449927022'
          //window.location.href = 'itms-services://?action=download-manifest&amp;url=https://zd.oss.haiouchat.com/manifest.plist'
          window.location.href =
            'https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5-%E5%AE%89%E5%85%A8%E5%8A%A0%E5%AF%86%E8%81%8A%E5%A4%A9%E4%BA%A4%E5%8F%8B%E8%BD%AF%E4%BB%B6/id1584062834'


        } else {
          window.location.href = 'https://www.haiouchat.com/app/haiou.apk'
        }


      },
      toDown(type) {
        var that = this;
        request.postWay(
          api.apiConfig.authUrl, {
            file_path: that.encodeToBase64(type)
          },
          function (response) {
            console.log(that.decodeFromBase64(response.auth_url))
            window.location.href = that.decodeFromBase64(response.auth_url)

          }
        );
      },
      encodeToBase64(str) {
        return Base64.encode(str);
      },

      decodeFromBase64(base64Str) {
        return Base64.decode(base64Str);
      },


    }
  }

</script>

//pc端样式
<style scoped>
  /* 当屏幕宽度大于或等于768像素时，改为浮动布局 */
  @media (min-width: 768px) {

    #mobile {
      display: none;
    }

    .main-1 {

      height: 900px;
      padding-left: 234px;
      background: linear-gradient(137deg, #E3EDFF 0%, #E5EFFF 100%);

      display: flex;
    }

    .main-1-1>div:first-child {
      margin-top: 125px;
      display: flex;
      align-items: center;
    }

    .main-1-1>div:first-child>div {
      width: 206px;
      height: 44px;
      background: rgba(67, 113, 255, 0.1);
      border-radius: 26px 26px 26px 26px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #4371FF;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      display: flex;
      align-items: center;

    }

    .main-1-1>div:first-child>div>img {
      width: 32px;
      height: 32px;
      margin-left: 6px;
      margin-right: 8px;
    }

    .main-1-1>div:first-child>img {
      width: 42px;
      height: 42px;
      position: relative;
      top: -22px;
      right: 20px;
    }

    .main-1-1>div:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 48px;
      color: #091D5A;
      line-height: 56px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 24px;
    }

    .main-1-1>div:nth-child(3) {

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #091D5A;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 32px;
    }

    .main-1-1>div:nth-child(4) {

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #091D5A;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 20px;
    }

    .main-1-1>div:nth-child(5) {
      text-align: left;
      margin-top: 44px;
    }

    .main-1-1>div:nth-child(5)>img {
      width: 170px;
      height: 170px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #FFFFFF;

    }

    .main-1-1>div:nth-child(6) {
      margin-top: 32px;
      display: flex;

    }

    .main-1-1>div:nth-child(6)>div {

      width: 199px;
      height: 66px;
      background: #4371FF;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      align-items: center;
      margin-right: 16px;
    }


    .main-1-1>div:nth-child(6)>div>img {
      width: 32px;
      height: 32px;
      margin-right: 12px;
      margin-left: 28px;
    }

    .main-1-1>div:nth-child(6)>div>div {
      display: flex;
      flex-direction: column;
    }

    .main-1-1>div:nth-child(6)>div>div>span:first-child {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 9px;
    }

    .main-1-1>div:nth-child(6)>div>div>span:last-child {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 5px;
    }

    .main-1-1>div:last-child {

      margin-top: 24px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #FF3F3F;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }



    .main-1-2 {
      position: relative;
      margin-top: 50px;
      margin-left: 30px;
    }

    .main-1-2>img {
      width: 700px;
      height: 700px;
      margin-left: 30px;

    }

    .main-1-2>div {
      width: 206px;
      height: 44px;
      background: rgba(255, 255, 255, 0.3);
      box-shadow: 0px 0px 20px 0px rgba(183, 207, 252, 0.78);
      border-radius: 26px 26px 26px 26px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #4371FF;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      display: flex;
      align-items: center;

      position: absolute;


    }

    .main-1-2>div>img {
      width: 32px;
      height: 32px;
      margin-left: 6px;
      margin-right: 8px;
    }

    .main-1-2>div:first-child {
      top: 300px;
      left: -105px;
    }

    .main-1-2>div:nth-child(2) {
      top: 70px;
      left: 515px;
    }

    .main-1-2>div:nth-child(3) {
      top: 630px;
      left: 400px;
    }

    .main-2 {
      height: 100%;
      background: #FFFFFF;
      border-radius: 0px 0px 0px 0px;
      text-align: center;


    }

    .main-2>img {
      margin-top: 60px;
      width: 1350px;
      height: 704px;

    }

    .main-3 {

      height: 100%;
      background: #FFFFFF;

      display: flex;
      flex-direction: column;
      align-items: center;

    }

    .main-3>span:first-child {


      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 48px;
      color: #292929;
      line-height: 72px;
      letter-spacing: 2px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin-top: 30px;
    }

    .main-3>span:nth-child(2) {

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #292929;
      line-height: 30px;
      letter-spacing: 1px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 10px;

    }

    .main-3>div {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-top: 30px;
      padding-left: 216px;
      padding-right: 216px;
    }

    .main-3>div>div {
      width: 450px;
      height: 290px;
      background: #F7F9FF;
      border-radius: 8px 8px 8px 8px;

      display: flex;
      flex-direction: column;
      align-items: center;



      margin-bottom: 24px;
    }

    .main-3>div>div:hover {
      background: #E2E9FF;
      box-shadow: 0px 0px 20px 0px #E7E7E7;
      border-radius: 8px 8px 8px 8px;
    }



    .main-3>div>div>img {
      width: 80px;
      height: 80px;
      margin-top: 40px;

    }

    .main-3>div>div>span:nth-child(2) {

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #292929;
      line-height: 36px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 22px;

    }

    .main-3>div>div>span:nth-child(3) {

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #999999;
      line-height: 18px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 14px;

    }


    .main-3>div>div>span:nth-child(4) {

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #4371FF;
      line-height: 24px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 14px;

    }







    .main-3-3 {


      background: #FFFFFF;

      display: flex;
      flex-direction: column;
      align-items: center;

    }

    .main-3-3>span:first-child {


      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 48px;
      color: #292929;
      line-height: 72px;
      letter-spacing: 2px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin-top: 30px;
    }

    .main-3-3>span:nth-child(2) {

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #292929;
      line-height: 30px;
      letter-spacing: 1px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 10px;

    }

    .main-3-3>div {
      width: 1465px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-around;
      margin-top: 30px;

    }

    .main-3-3>div>div {
      width: 380px;
      height: 592px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;

      display: flex;
      flex-direction: column;
      align-items: center;


      padding-right: 50px;
      padding-left: 50px;
      margin-bottom: 80px;
    }

    .main-3-3>div>div:hover {

      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px 8px 8px 8px;
    }

    .main-3-3>div>div>img {
      width: 200px;
      height: 396px;
      margin-top: 22px;

    }

    .main-3-3>div>div>span:nth-child(2) {

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #292929;
      line-height: 36px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 22px;

    }

    .main-3-3>div>div>span:nth-child(3) {

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #999999;
      line-height: 25px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 14px;

    }





    .main-4 {

      height: 90vh;
      background: #FFFFFF;


      display: flex;
      flex-direction: column;
      align-items: center;

    }

    .main-4>div:first-child {

      display: flex;
      flex-direction: row;
      z-index: 9;

    }


    .main-4>div:first-child>img {

      width: 580px;
      height: 700px;

    }

    .main-4>div:first-child>div>p:first-child {

      margin-top: 150px;
      margin-bottom: 15px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 64px;
      color: #292929;
      line-height: 96px;
      letter-spacing: 3px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }

    .main-4>div:first-child>div>p:last-child {

      width: 620px;

      margin-top: 0px;
      margin-bottom: 0px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #292929;
      line-height: 48px;
      letter-spacing: 1px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }



    .main-4>div:last-child>img {

      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 1920px;
      height: 303px;

    }




    .main-5 {

      height: 90vh;
      background: #FFFFFF;


      display: flex;
      flex-direction: column;
      align-items: center;

    }

    .main-5>div:first-child {

      display: flex;
      flex-direction: row;
      z-index: 9;

    }


    .main-5>div:first-child>img {

      width: 580px;
      height: 700px;

    }

    .main-5>div:first-child>div>p:first-child {

      margin-top: 150px;
      margin-bottom: 15px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 64px;
      color: #292929;
      line-height: 96px;
      letter-spacing: 3px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }

    .main-5>div:first-child>div>p:last-child {

      width: 620px;

      margin-top: 0px;
      margin-bottom: 0px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #292929;
      line-height: 48px;
      letter-spacing: 1px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }



    .main-5>div:last-child>img {

      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 1920px;
      height: 303px;

    }





    .main-6 {

      height: 90vh;
      background: #FFFFFF;


      display: flex;
      flex-direction: column;
      align-items: center;

    }

    .main-6>div:first-child {

      display: flex;
      flex-direction: row;
      z-index: 9;

    }


    .main-6>div:first-child>img {

      width: 580px;
      height: 700px;

    }

    .main-6>div:first-child>div>p:first-child {

      margin-top: 150px;
      margin-bottom: 15px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 64px;
      color: #292929;
      line-height: 96px;
      letter-spacing: 3px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }

    .main-6>div:first-child>div>p:last-child {

      width: 620px;

      margin-top: 0px;
      margin-bottom: 0px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #292929;
      line-height: 48px;
      letter-spacing: 1px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }



    .main-6>div:last-child>img {

      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 1920px;
      height: 303px;

    }

    .main-7 {

      background: #FFFFFF;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .main-7>div:first-child>p:first-child {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 48px;
      color: #292929;
      line-height: 72px;
      letter-spacing: 2px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 30px;
      margin-bottom: 0px;
    }

    .main-7>div:first-child>p:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #292929;
      line-height: 30px;
      letter-spacing: 1px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 16px;
      margin-bottom: 60px;
    }



    .main-7>div:first-child>img {

      width: 100%;
    }

    .main-7>div:last-child {

      background: #F8F8F8;
    }


  }

</style>

//移动端样式
<style scoped>
  /* 当屏幕宽度小于或等于768像素时，应用以下样式 */
  @media (max-width: 768px) {
    #pc {
      display: none;
    }
  }

  .mobile-1 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mobile-1>div:first-child {
    width: 100%;
    height: 312px;
    background-image: url('../img/mobile/Frame4527@2x.png');
    /* 背景图路径 */
    background-position: center center;
    /* 水平垂直居中 */
    background-size: cover;
    /* 背景图覆盖整个容器 */

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mobile-1>div:first-child>p:first-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 36px;
    color: #091D5A;
    line-height: 44px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 72px;
    margin-bottom: 0;
  }

  .mobile-1>div:first-child>p:nth-child(2) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #091D5A;
    line-height: 28px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 8px;
    margin-bottom: 0;
  }

  .mobile-1>div:first-child>p:nth-child(3) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 300;
    font-size: 12px;
    color: #091D5A;
    line-height: 14px;
    letter-spacing: 2px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 0;
  }

  .mobile-1>div:first-child>div {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 53px;
  }

  .mobile-1>div:first-child>div>div {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 136px;
    height: 40px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 4px 4px 4px 4px;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;


  }

  .mobile-1>div:first-child>div>div:first-child {
    margin-right: 39px;


  }


  .mobile-1>div:first-child>div>div>img {
    width: 20px;
    height: 20px;
    margin-left: 26px;
    margin-right: 8px;
  }

  .mobile-1>div:nth-child(2)>p:first-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #292929;
    line-height: 21px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 18px;
    margin-bottom: 8px;
  }

  .mobile-1>div:nth-child(2)>p:last-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #292929;
    line-height: 14px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-bottom: 16px;
  }

  .mobile-1>div:last-child {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-left: 16px;
    padding-right: 16px;
  }

  .mobile-1>div:last-child>div {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 168px;
    height: 68px;
    background: #FFFFFF;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 4px 4px 4px 4px;
    margin-top: 8px;
  }

  .mobile-1>div:last-child>div>img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
    margin-left: 14px;
  }

  .mobile-1>div:last-child>div>div>p:first-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 12px;
    margin-bottom: 4px;
  }

  .mobile-1>div:last-child>div>div>p:last-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 0px;
  }

  .mobile-2 {
    margin-top: 40px;
    text-align: center;
  }

  .mobile-2>img {
    width: 328px;
    height: 568px;

  }

  .mobile-3 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mobile-3>p:first-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #292929;
    line-height: 27px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 60px;
    margin-bottom: 0px;
  }

  .mobile-3>p:nth-child(2) {
    width: 312px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #292929;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 12px;
    margin-bottom: 0px;
  }

  .mobile-3>div {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-left: 23px;
    margin-right: 24px;
    margin-top: 8px;

  }



  .mobile-3>div>div {
    width: 160px;
    height: 146px;
    background: #F6F9FF;
    border-radius: 4px 4px 4px 4px;
    margin-top: 8px;

    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .mobile-3>div>div>img {
    width: 36px;
    height: 36px;
    margin-top: 16px;

  }

  .mobile-3>div>div>p:nth-child(2) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #292929;
    line-height: 21px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 5px;
    margin-bottom: 0px;

  }

  .mobile-3>div>div>p:nth-child(3) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #999999;
    line-height: 12px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    width: 140px;
    margin-top: 8px;
    margin-bottom: 0px;

  }

  .mobile-3>div>div>p:nth-child(4) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #4371FF;
    line-height: 15px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 12px;
    margin-bottom: 0px;

  }

  .mobile-4 {

    width: 328px;
    height: 380px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px 8px 8px 8px;
    margin-left: auto;
    margin-right: auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
  }

  .mobile-4>img {
    width: 150px;
    height: 258px;
    margin-top: 16px;
  }


  .mobile-4>p:nth-child(2) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #292929;
    line-height: 27px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 0px;
  }

  .mobile-4>p:nth-child(3) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #292929;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    width: 312px;
    margin-top: 12px;
    margin-bottom: 0px;
    margin-right: 16px;
    margin-left: 16px;
  }







  .mobile-5 {

    width: 328px;
    height: 380px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px 8px 8px 8px;
    margin-left: auto;
    margin-right: auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
  }

  .mobile-5>img {
    width: 150px;
    height: 258px;
    margin-top: 16px;
  }


  .mobile-5>p:nth-child(2) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #292929;
    line-height: 27px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 0px;
  }

  .mobile-5>p:nth-child(3) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #292929;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    width: 312px;
    margin-top: 12px;
    margin-bottom: 0px;
    margin-right: 16px;
    margin-left: 16px;
  }





  .mobile-6 {

    width: 328px;
    height: 380px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px 8px 8px 8px;
    margin-left: auto;
    margin-right: auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
  }

  .mobile-6>img {
    width: 150px;
    height: 258px;
    margin-top: 16px;
  }


  .mobile-6>p:nth-child(2) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #292929;
    line-height: 27px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 0px;
  }

  .mobile-6>p:nth-child(3) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #292929;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    width: 312px;
    margin-top: 12px;
    margin-bottom: 0px;
    margin-right: 16px;
    margin-left: 16px;
  }






  .mobile-7 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .mobile-7>p:first-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #292929;
    line-height: 27px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 60px;
    margin-bottom: 0px;
  }

  .mobile-7>p:nth-child(2) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #292929;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    width: 312px;
    margin-top: 12px;
    margin-bottom: 0px;
  }

  .mobile-7>img {
    width: 100%;
    height: 538px;
    margin-top: 22px;
  }

  .mobile-3-3 {
    display: flex;
    flex-flow: column;
    align-items: center;
  }


  .mobile-3-3>p:nth-child(1) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #292929;
    line-height: 27px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin-top: 32px;
    margin-bottom: 0;
  }

  .mobile-3-3>p:nth-child(2) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #292929;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin-top: 12px;
    margin-bottom: 0;
    margin-right: 31px;
    margin-left: 31px;
  }

</style>



// WEBPACK FOOTER //
// src/view/index.vue